import view from "../../views/support";
import KTAPI from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";
import { errorMsg } from "./offscreen.controller";


import { _user, _handler } from "../classes/index.classes";




let support = {
    render: () => {        
        return view;
    },
    after_render: async (data) => {    
                
        KTScroll.init();
        $("#kt_content_container").localize();

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};


$(document).ready(function(){    
    
});






export default support;